import Container from "@mui/material/Container";
import { DynamicForm } from "../components/form/DynamicForm";
// import { DynamicFormContextProvider } from "../contexts/dynamic-form/DynamicFormContextProvider";
import { useDynamicForm } from "../contexts/dynamic-form/useDynamicForm";
import { Box } from "@mui/material";

export const FormPage = () => {
  const { form, session } = useDynamicForm();
  return (
    <>
      {/* <DynamicFormContextProvider formId="bz8xla96iyx7lilbzbksp8y1"> */}
      <Box sx={{ pb: 4 }}>
        <Container maxWidth="md">
          <DynamicForm dynamicForm={form} session={session} />
        </Container>
      </Box>
      {/* </DynamicFormContextProvider> */}
    </>
  );
};
